import { xCrossCorrelation } from "./xCrossCorrelation.js";
/**
 * Calculates the auto-correlation of an array
 * @param A - the array for which to calculate the auto-correlation
 * @param options - options.
 */
export function xAutoCorrelation(A, options = {}) {
    return xCrossCorrelation(A, A, options);
}
//# sourceMappingURL=xAutoCorrelation.js.map